import script from "./SupplierData.vue?vue&type=script&lang=ts&setup=true&name=StockList"
export * from "./SupplierData.vue?vue&type=script&lang=ts&setup=true&name=StockList"

const __exports__ = script;

export default __exports__